import { render, staticRenderFns } from "./realEstateTreasureRent.vue?vue&type=template&id=8e78a150&scoped=true&"
import script from "./realEstateTreasureRent.vue?vue&type=script&lang=js&"
export * from "./realEstateTreasureRent.vue?vue&type=script&lang=js&"
import style0 from "./realEstateTreasureRent.vue?vue&type=style&index=0&lang=css&"
import style1 from "./realEstateTreasureRent.vue?vue&type=style&index=1&id=8e78a150&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e78a150",
  null
  
)

export default component.exports